export default "__VITE_ASSET__Ded3F7hI__"